import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    pending: 0,
    module: null,
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        // true starts one blocking request, false ends one; the overlay stays on until all have ended.
        setLoading: (state, action) => {
            state.pending = Math.max(0, state.pending + (action.payload ? 1 : -1));
            state.loading = state.pending > 0;
        },
        setModuleLoading: (state, action) => {
            state.module = action.payload;
        },
    },
});

export const { setLoading, setModuleLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
